import React, { useEffect } from 'react';
import Header from "components/UIComponents/Header/Header";
import InnerTitleCont from 'components/UIComponents/InnerTitleCont/InnterTitleState';
import Footer from 'components/UIComponents/Footer/Footer';
import { Container, Row, Col } from 'react-bootstrap';
import { useParams } from "react-router-dom";
import formStyle from './formStyle.module.scss';
import { useTranslation, Trans } from 'react-i18next';
import icon from './../../global/images/aisIcon.png';
import PhoneInput from 'react-phone-number-input'

const label = {
    color: '#2c2276',
    fontSize: '0.8rem',
    fontFamily: 'Cairo-Bold',
    marginTop: '2rem'
};

const fieldBackground = {
    fontFamily: 'Cairo-Bold',
    textAlign: 'center',
    border: '2px solid #CBD5E0',
    height: '55px',
    borderRadius: '0.25rem',
    padding: '16px 20px',
    fontSize: '16px',
    fontWeight: '500',
    background: '#80808080',
    color: '#333'
};

const field = {
    fontFamily: 'Cairo-Bold',
    textAlign: 'center',
    border: '2px solid #CBD5E0',
    height: '55px',
    borderRadius: '0.25rem',
    padding: '16px 20px',
    fontSize: '16px',
    fontWeight: '500',
    color: '#333'
};

const fileUploader = {
    position: 'absolute',
    top: '66%',
    left: '10%',
    fontSize: '0.8rem',
    fontFamily: 'Cairo-Bold',
    color: '#03b2cb',
    display: 'flex',
    justifyContent: 'space-between',
    width: '80%'
};

const form = (type) => {

    // const { t, i18n } = useTranslation(['auth', 'common']);

    return (
        <Container className='mb-4 py-3'>
            <Row>
                <Col md={6}>
                    <label style={label}>Name in Arabic</label>
                    <input
                        name="Login_Name"
                        type="text"
                        value={'احمد يحيي ابراهيم'}
                        autoComplete="off"
                        style={fieldBackground}
                    />
                </Col>

                <Col md={6}>
                    <label style={label}>Name in English</label>
                    <input
                        name="Login_Name"
                        type="text"
                        value={'Ahmed Yihia Ibrahim'}
                        autoComplete="off"
                        style={fieldBackground}
                    />
                </Col>

                <Col md={6} className={formStyle.form}>
                    <label style={label}>Phone Number</label>
                    <PhoneInput
                        international
                        countryCallingCodeEditable={false}
                        defaultCountry="AE"
                        name="Client_Phone"
                        id="Client_Phone"
                        className={formStyle.phoneInput}
                        value={'+971 50 551 2338'}
                    />
                    {/* <input
                        name="Login_Name"
                        type="text"
                        autoComplete="off"
                        value={'+971 50 551 2338'}
                        dir='ltr'
                        style={field}
                    /> */}
                </Col>

                <Col md={6}>
                    <label style={label}>Email</label>
                    <input
                        name="Login_Name"
                        type="text"
                        value={'Ahmed.Yihia1@gmail.com'}
                        autoComplete="off"
                        dir='ltr'
                        style={field}
                    />
                </Col>

                <Col md={6}>
                    <label style={label}>Emirates ID Number</label>
                    <input
                        name="Login_Name"
                        type="text"
                        autoComplete="off"
                        value={'784-1986-1545487-8'}
                        dir='ltr'
                        style={fieldBackground}
                    />
                </Col>

                <Col md={6}></Col>

                {type == ':2' &&
                    <>
                        <Col md={6}>
                            <label style={label}>Business License Number</label>
                            <input
                                name="Login_Name"
                                type="text"
                                autoComplete="off"
                                dir='ltr'
                                style={field}
                            />
                        </Col>

                        <Col md={6}>
                            <label style={label}>License Photo</label>
                            <input
                                name="Login_Name"
                                type="text"
                                autoComplete="off"
                                dir='ltr'
                                style={field}
                                disabled
                            />
                            <div style={fileUploader}>
                                <span>Select a File</span>
                                <span>
                                    <svg width="30" height="30" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M32 32L24 24L16 32" stroke="#03b2cb" strokeOpacity="1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M24 24V42" stroke="#03b2cb" strokeOpacity="1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M40.7789 36.78C42.7296 35.7166 44.2706 34.0338 45.1587 31.9973C46.0468 29.9608 46.2314 27.6865 45.6834 25.5334C45.1353 23.3803 43.8859 21.4711 42.1323 20.1069C40.3786 18.7428 38.2207 18.0015 35.9989 18H33.4789C32.8736 15.6585 31.7453 13.4847 30.1788 11.642C28.6124 9.79933 26.6486 8.33573 24.4351 7.36124C22.2216 6.38676 19.816 5.92675 17.3992 6.01579C14.9823 6.10484 12.6171 6.74063 10.4813 7.87536C8.34552 9.01009 6.49477 10.6142 5.06819 12.5672C3.64161 14.5202 2.67632 16.7711 2.2449 19.1508C1.81348 21.5305 1.92715 23.9771 2.57737 26.3066C3.22759 28.636 4.39743 30.7878 5.99894 32.6" stroke="#03b2cb" strokeOpacity="1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M32 32L24 24L16 32" stroke="#03b2cb" strokeOpacity="1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </span>
                            </div>
                        </Col>
                    </>
                }
            </Row>
        </Container>
    )
}

const FormDemo = () => {

    const { type } = useParams()
    const { t, i18n } = useTranslation(['auth', 'common']);

    return (
        <>
            <Header />
            <InnerTitleCont
                leaveBtn={false}
            />
            <Row className="justify-content-center mx-md-0 mt-md-0 mx-1 mt-2">
                <Col lg={12} md={12} sm={12} className={formStyle.cardStyle}>
                    <div className="row">
                        <Col md={12}>
                            <div className={formStyle.form_wrapper}>
                                <div className="row justify-content-center m-sm-4">
                                    <div className="col-md-8">
                                        <div className={formStyle.form_box}>
                                            <div className={formStyle.heading}>
                                                <Trans i18nKey={'Register a new account'} t={t} />
                                                <span className={[formStyle.heading, 'd-flex align-items-center justify-content-between'].join(' ')}>
                                                    {type == ':1' ?
                                                        <>
                                                            <span className={formStyle.imgwrapper}>
                                                                <img
                                                                    className={[formStyle.dealerImg, 'mb-1'].join(' ')}
                                                                    src={icon}
                                                                    width='20px'
                                                                    height='20px'
                                                                />
                                                            </span>
                                                            <span>
                                                                <Trans i18nKey={'afrad'} t={t} />
                                                            </span>
                                                        </>
                                                        : type == ':2' ?
                                                            <>
                                                                <span className={formStyle.imgwrapper}>
                                                                    <img className={[formStyle.dealerImg, 'mb-1'].join(' ')} width='20px' height='20px' src={icon} />
                                                                </span>
                                                                <Trans i18nKey={'Partners'} t={t} />
                                                            </>
                                                            : null}
                                                </span>
                                            </div>

                                            <div
                                                style={{
                                                    width: '90%',
                                                    height: '1px',
                                                    background: '#eeeeee'
                                                }}
                                            ></div>

                                            {form(type)}

                                            <div className={[formStyle.form, 'd-flex'].join(' ')}>
                                                <Col sm={6}>
                                                    <button
                                                        type="button"
                                                        className={[
                                                            formStyle.secBtn,
                                                            formStyle.formBtn,
                                                        ].join(' ')}
                                                        onClick={() => { }}
                                                    >
                                                        {t('pvStep')}
                                                    </button>
                                                </Col>

                                                <Col sm={6}>
                                                    <button
                                                        type="button"
                                                        className={[formStyle.primBtn, formStyle.formBtn].join(' ')}
                                                    // disabled
                                                    >
                                                        <Trans i18nKey={'register'} t={t} />
                                                    </button>
                                                </Col>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </div>
                </Col>
            </Row>
            <Footer />
        </>
    )
}

export default FormDemo;

